import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FileText, Receipt, X } from "lucide-react";
import { fetchPastOrders, proformaParts, ron } from "@/lib/bf";

export default function BFMyOrders({ preview }) {
  const [orders, setOrders] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const lead = localStorage.getItem("bf_lead_id");
    const load = () => lead && fetchPastOrders(lead).then((l) => setOrders(l.filter((o) => preview || !o.preview))).catch(() => {});
    load();
    window.addEventListener("bf-order-sent", load);
    return () => window.removeEventListener("bf-order-sent", load);
  }, [preview]);
  if (!orders.length) return null;
  return (
    <>
      <button type="button" className="bf-myorders-btn" onClick={() => setOpen(true)} data-testid="bf-myorders-open">
        <Receipt size={15} /> Comenzile mele <b>{orders.length}</b>
      </button>
      {open && createPortal(
        <div className="bf-myorders" onClick={() => setOpen(false)} role="dialog" data-testid="bf-myorders">
          <div className="bf-myorders-box" onClick={(e) => e.stopPropagation()}>
            <header>
              <h3>Comenzile mele</h3>
              <button type="button" onClick={() => setOpen(false)} aria-label="Închide" data-testid="bf-myorders-close"><X size={18} /></button>
            </header>
            <p>Proformele trimise de salonul tău. Le poți descărca oricând.</p>
            <ul>
              {orders.map((o) => (
                <li key={o.id} data-testid={`bf-myorders-${o.no}`}>
                  <div><b>{o.no}</b><small>{o.date} · {o.lines.reduce((s, l) => s + l.q, 0)} buc.</small></div>
                  <strong>{ron(o.total)}</strong>
                  {proformaParts(o).map((p) => (
                    <a key={p.no} href={p.xlsx} data-testid={`bf-myorders-xlsx-${p.no}`}><FileText size={14} /> Excel{p.tag}</a>
                  ))}
                </li>
              ))}
            </ul>
          </div>
        </div>,
        document.body,
      )}
    </>
  );
}
